export default "__VITE_ASSET__a0eb437b__"